import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import style from "./logout.scss";
import { LoadingIndicator } from "components/loading-indicator/LoadingIndicator";
import { LOGIN_ROUTE } from "components/router/Routes";
import { Breakpoint } from "domain/breakpoints";
import { userSessionService } from "services/user/UserSessionService";
import { clearAllTenantDetails } from "store/tenantDetails";
import { logger } from "utils/logging";
import { RepositoryKey, setObject } from "utils/repository";

const MAP_STATE = () => ({});
const MAP_DISPATCH = { clearAllTenantDetails };
const CONNECTOR = connect(MAP_STATE, MAP_DISPATCH);

const LogoutView = (props: ConnectedProps<typeof CONNECTOR>): JSX.Element => {
    const { t } = useTranslation();
    const [showErrorMessage, setShowErrorMessage] = React.useState<boolean>(false);

    React.useEffect(() => {
        props.clearAllTenantDetails();
        userSessionService
            .logout()
            .then(() => {
                window.location.replace(LOGIN_ROUTE.path);
            })
            .catch((e) => {
                setShowErrorMessage(true);
                logger.error("Failed to logout", e);
            });

        setObject(RepositoryKey.BANNER_DISMISSED, false);
        if (window.innerWidth <= Breakpoint.MD) {
            setObject(RepositoryKey.SUB_NAVIGATION, false);
        } else if (window.innerWidth > Breakpoint.MD) {
            setObject(RepositoryKey.SUB_NAVIGATION, true);
        }
    }, []);

    return showErrorMessage ? (
        <div className={style.errorMessage}>{t("Logout.errorMessage")}</div>
    ) : (
        <LoadingIndicator />
    );
};

export default CONNECTOR(LogoutView);
